//@flow

import {generateProductCatalogueApi, getProductCatalogueApi} from './api';
import type {ProductCatalogue} from '../../entities';

export function generateProductCatalogueService(): Promise<ProductCatalogue> {
  return generateProductCatalogueApi().toPromise();
}

export function getProductCatalogueService(): Promise<ProductCatalogue> {
  return getProductCatalogueApi().toPromise();
}
